import { render, staticRenderFns } from "./ContactOrderTable.vue?vue&type=template&id=e83e0e06&scoped=true&"
import script from "./ContactOrderTable.vue?vue&type=script&lang=js&"
export * from "./ContactOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactOrderTable.vue?vue&type=style&index=0&id=e83e0e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83e0e06",
  null
  
)

export default component.exports